export const ITEMS_PER_SCROLL_COUNT = 10;

export const LOADING_MINIMAL_DURATION = 200;
